import React, { useEffect, useState } from "react";
import { Col, Row, Space, Typography, Table } from "antd";
import { dryNetRetinoscopyColumnsTb1 } from "./config";
import { useAppSelector } from "redux/hooks";
import { infoDetailsProps } from "types/models/infoDetailsProps";
import { optionsDrugUsed } from "types/config/dry-net-retinoscopy";
import { data1ColRT } from "../config";

const DryNetRetinoscopyPrint = ({data}) => {
 

  const [dataDryNetRetinoscopyPrint, setDataDryNetRetinoscopyPrint] = useState({
    left: data1ColRT,
    right: data1ColRT,
  });

  useEffect(() => {
    if (
      data &&
      data?.left &&
      data?.left?.tb1 &&
      (data?.left?.tb1?.sph ||
        data?.left?.tb1?.cyl ||
        data?.left?.tb1?.axis ||
        data?.left?.tb1?.reflexType)
    ) {
      setDataDryNetRetinoscopyPrint((pre) => ({
        ...pre,
        left: [
          {
            key: 2,
            none: "Xa",
            sph: data?.left?.tb1?.sph && data?.left?.tb1?.sph[0],
            cyl: data?.left?.tb1?.cyl && data?.left?.tb1?.cyl[0],
            axis:
              data?.left?.tb1?.axis && data?.left?.tb1?.axis[0],
            reflexType:
              data?.left?.tb1?.reflexType &&
              data?.left?.tb1?.reflexType[0],
          },
        ],
      }));
    }else {
      setDataDryNetRetinoscopyPrint((pre) => ({
        ...pre,
        left: data1ColRT,
      }));
    }
    if (
      data &&
      data?.right &&
      data?.right?.tb1 &&
      (data?.right?.tb1?.sph ||
        data?.right?.tb1?.cyl ||
        data?.right?.tb1?.axis ||
        data?.right?.tb1?.reflexType)
    ) {
      setDataDryNetRetinoscopyPrint((pre) => ({
        ...pre,
        right: [
          {
            key: 2,
            none: "Xa",
            sph:
              data?.right?.tb1?.sph && data?.right?.tb1?.sph[0],
            cyl:
              data?.right?.tb1?.cyl && data?.right?.tb1?.cyl[0],
            axis:
              data?.right?.tb1?.axis && data?.right?.tb1?.axis[0],
            reflexType:
              data?.right?.tb1?.reflexType &&
              data?.right?.tb1?.reflexType[0],
          },
        ],
      }));
    }else {
      setDataDryNetRetinoscopyPrint((pre) => ({
        ...pre,
        right: data1ColRT,
      }));
    }
  }, [data]);

  const value = [
    {
      key: 1,
      data: dataDryNetRetinoscopyPrint.right,
      
      atDistance: data?.right?.tb2?.atDistance,
      comments: data?.right?.tb2?.comments,
      drugUsed:
        data?.right?.tb2 &&
        data?.right &&
        data?.right?.tb2?.drugUsed,
    },
    {
      key: 2,
      data: dataDryNetRetinoscopyPrint.left,
      
      atDistance: data?.left?.tb2?.atDistance,
      comments: data?.left?.tb2?.comments,
      drugUsed: data?.left?.tb2?.drugUsed,
    },
  ];
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Row gutter={[16, 8]}>
        {value.map((item) => {
          const res = optionsDrugUsed.find((e) => {
            if (e.value === item.drugUsed) {
              return e.label;
            }
          });

          return (
            <Col span={12} key={item.key}>
              <Space direction="vertical" style={{width:'100%'}}>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  Soi bóng đồng tử:
                </Typography.Text>
                <Table

                  dataSource={item.data}
                  columns={dryNetRetinoscopyColumnsTb1}
                  bordered={true}
                  pagination={false}
                  className="table-print"
                />
                {item?.atDistance && (
                  <Row>
                    <Typography className="title-print" style={{paddingRight:'8px'}}>
                      Khoảng cách:
                    </Typography>
                    <Typography.Text>
                      {item.atDistance}
                    </Typography.Text>
                  </Row>
                )}
                {item?.comments && (
                  <Row>
                    <Typography className="title-print" style={{paddingRight:'8px'}}>Nhận xét:</Typography>
                    <Typography.Text>
                      {item.comments}
                    </Typography.Text>
                  </Row>
                )}
                {item?.drugUsed && (
                  <Row>
                    <Typography className="title-print" style={{paddingRight:'8px'}}>Thuốc:</Typography>
                    <Typography.Text ellipsis={true}>
                      {res?.label}
                    </Typography.Text>
                  </Row>
                )}
              </Space>
            </Col>
          );
        })}
      </Row>
    </Space>
  );
};

export default DryNetRetinoscopyPrint;
